/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import { Button, Input } from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

const TestRegex = ({
    filterExpression, setFilterExpression, validationInput, onValidateRule, isTestRegexLoading, handleValidationInput, addNewInput, regExResult, removeInput,
}) => {
    const getRegexSucessComponent = () => (
        <span
            className="appkiticon a-btn-icon icon-check-mark-fill"
            style={{
                width: '0.5rem',
                color: '#22992E',
                marginLeft: '0.2rem',
            }}
        />
    );
    const getRegexErrorComponent = () => (
        <span
            className="appkiticon a-btn-icon icon-close-fill"
            style={{ width: '0.5rem', color: 'red', marginLeft: '0.2rem' }}
        />
    );
    const getRegexComponent = result => {
        let span;
        switch (result) {
            case true:
                span = getRegexSucessComponent();
                break;
            case false:
                span = getRegexErrorComponent();
                break;
            default:
                span = '';
                break;
        }
        return span;
    };
    return (
        <div className="rule-validation-panel">
            <Row>
                <Col md={9}>
                    <h6>
                        RegEx Testing Area
                    </h6>
                    <Row>
                        <Col>
                            <Input
                                type="text"
                                name="regExString"
                                value={filterExpression}
                                onChange={e => {
                                    setFilterExpression(e);
                                }}
                                placeholder="Regular Expression"
                            />
                        </Col>
                        <Col md={1} style={{ paddingLeft: 0 }}>
                            <Button kind="primary" size="lg" onClick={onValidateRule} isLoading={isTestRegexLoading}> Check </Button>
                        </Col>
                    </Row>
                    <h6 style={{ marginTop: '1rem' }}>
                        Test Strings
                    </h6>
                    {validationInput.map((input, index) => (
                        <div key={index} style={{ marginTop: '0.5rem' }}>
                            <Row>
                                <Col md={7}>
                                    <Input
                                        type="text"
                                        name="vlaidationInput"
                                        value={input}
                                        onChange={e => {
                                            handleValidationInput(e, index);
                                        }}
                                        suffix={
                                            getRegexComponent(regExResult[index])
                                        }
                                    />
                                </Col>
                                <Col style={{ paddingLeft: 0, paddingTop: '0.2rem' }}>
                                    {
                                        (validationInput.length >= 1 && ((index + 1) === validationInput.length))
                                            ? (
                                                <>
                                                    {(validationInput.length > 1)
                                                        && (
                                                            <Button kind="secondary" size="sm" onClick={() => removeInput(index)} style={{ marginRight: '0.5rem' }}>
                                                                <span className="appkiticon a-btn-icon icon-minus-fill" style={{ width: '0.5rem', marginLeft: '0.2rem' }} />
                                                            </Button>
                                                        )}
                                                    <Button kind="secondary" size="sm" onClick={addNewInput}>
                                                        <span className="appkiticon a-btn-icon icon-plus-fill" style={{ width: '0.5rem', marginLeft: '0.2rem' }} />
                                                    </Button>
                                                </>
                                            ) : (
                                                <Button kind="secondary" size="sm" onClick={() => removeInput(index)}>
                                                    <span className="appkiticon a-btn-icon icon-minus-fill" style={{ width: '0.5rem', marginLeft: '0.2rem' }} />
                                                </Button>
                                            )
                                    }
                                </Col>
                            </Row>
                        </div>
                    ))}
                </Col>
            </Row>
        </div>
    );
};

export default TestRegex;
